import * as yup from "yup";

import {
  Validation,
  ImportFieldValueType
} from "src/core/shared/api/importSetting.api";

/**
 * @description Generates a yup schema for a field type based on specified validation rules.
 *
 * @param {Validation} validation - The validation rules to apply to the schema.
 * @param {ImportFieldType} type - The type of field to generate validation for.
 * @returns {yup.StringSchema<string> | yup.NumberSchema<number>}
 */
export const validateField = (validation: Validation, type: ImportFieldValueType) => {
  if (!validation) {
    throw new Error("Validation is required when validating generating yup schema from header mapping");
  }

  let schema: yup.StringSchema | yup.NumberSchema = yup.string();

  // Account for type
  switch (type) {
    case "email":{
      schema = schema.email();
      break;
    }

    case "phone": {
      schema = schema.matches(/^(|\+\d{2})(\d{10,11})$/);
      break;
    }

    case "number": {
      schema = yup.number();
      break;
    }

    default:
      schema;
      break;
  }

  // Account for validation
  if (validation) {
    if (validation.min) {
      schema = schema.min(validation.min);
    }

    if (validation.max) {
      schema = schema.max(validation.max);
    }

    if (validation.required) {
      schema = schema.required();
    }

    if (validation.regex && schema instanceof yup.string) {
      schema = schema.matches(new RegExp(validation.regex), validation.regexMessage);
    }
  }

  return schema;
};
